import {
    CodeDocIcon, ExamIcon,
    HtmlDocIcon,
    ImageDocIcon,
    PdfDocIcon,
    SlideshowDocIcon,
    TextDocIcon,
    VideoDocIcon,
    UnknownDocIcon,
} from "../../assets/icons";
import React from "react";

const IconMaterial = ({type, width = '30px'}) => {

    return <span style={{width: width}}>
        { type === 'html' && <HtmlDocIcon/> }
        { type === 'text' && <TextDocIcon/> }
        { type === 'pdf' && <PdfDocIcon/> }
        { type === 'image' && <ImageDocIcon/> }
        { type === 'video' && <VideoDocIcon/> }
        { type === 'code' && <CodeDocIcon/> }
        { type === 'slideshow' && <SlideshowDocIcon/> }
        { type === 'testing' && <ExamIcon/> }
        { type === 'file' && <UnknownDocIcon/> }
    </span>;

}

export default IconMaterial;
